import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import { Link } from "react-scroll";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import logo from "../assets/iss_logo.png";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Links: [
      { label: "Home", target: "hero" },
      { label: "Services", target: "services" },
      { label: "Pricing", target: "pricing" },
      { label: "About", target: "about" },
      { label: "Contact", target: "contact" },
    ],
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.default",
        borderTop: "1px solid rgba(0, 168, 255, 0.2)",
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <Box
                component="img"
                src={logo}
                alt="ISS Logo"
                sx={{
                  height: 50,
                  width: "auto",
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  background:
                    "linear-gradient(135deg, #00a8ff 0%, #0066cc 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Intelligent Signal Solutions
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", mb: 2, lineHeight: 1.8 }}
            >
              Fast, secure, and reliable hosted solutions for your business.
              Over 30 years of combined experience serving commercial and
              government customers.
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                sx={{
                  color: "text.secondary",
                  "&:hover": {
                    color: "primary.main",
                    bgcolor: "rgba(0, 168, 255, 0.1)",
                  },
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                sx={{
                  color: "text.secondary",
                  "&:hover": {
                    color: "primary.main",
                    bgcolor: "rgba(0, 168, 255, 0.1)",
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {footerLinks.Links.map((link) => (
                <Link
                  key={link.target}
                  to={link.target}
                  spy={true}
                  smooth={true}
                  duration={500}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      "&:hover": {
                        color: "primary.main",
                      },
                      transition: "color 0.3s ease",
                    }}
                  >
                    {link.label}
                  </Typography>
                </Link>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Contact Info
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                <strong>Email:</strong> contact@intelligentsignalsolutions.com
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                <strong>Phone:</strong> (910) 513-5288
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                <strong>Address: 815 Stamper Rd, Fayetteville, NC 28303</strong> 
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: "1px solid rgba(0, 168, 255, 0.1)",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            © {currentYear} Intelligent Signal Solutions LLC. All Rights
            Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
